import { Steps } from "antd";
import { STATUS, STATUS_LABEL } from "features/ConsultRequest/core/constants";
import { formatDateTime } from "features/ConsultRequest/core/utils";

const CURRENT_INDEX = { WAITING_ASSIGN: 0, WAITING_QUOTE: 1, QUOTED: 2, WON: 3, LOST: 3, CANCELLED: 3 };

/** Thời gian lấy từ progressMilestones (PW4), không gọi PW13. */
export default function ProgressSteps({ status, milestones }) {
  const m = milestones || {};
  const final = [STATUS.WON, STATUS.LOST, STATUS.CANCELLED].includes(status);
  const steps = [
    { title: STATUS_LABEL.WAITING_ASSIGN, time: m.createdAt },
    { title: STATUS_LABEL.WAITING_QUOTE, time: m.firstAssignedAt },
    { title: STATUS_LABEL.QUOTED, time: m.lastQuotedAt },
    { title: final ? STATUS_LABEL[status] : "Kết quả", time: m.closedAt },
  ];
  return (
    <Steps current={CURRENT_INDEX[status] ?? 0} size="small">
      {steps.map((s) => (
        <Steps.Step
          key={s.title}
          title={s.title}
          description={<span data-testid="step-time">{formatDateTime(s.time)}</span>}
        />
      ))}
    </Steps>
  );
}
